import Video from 'app/components/tv/models/video';
import {ApiVideo} from 'app/components/tv/apiResources/apiVideo';

const START_OFFSET = 17;
const VIDEO_DURATION = 45;

export default class StaigeVideo extends Video {
  constructor(data: ApiVideo) {
    super(data);
  }

  get startTime(): number {
    return this.startSec ? this.startSec - START_OFFSET : 0;
  }

  get videoDuration(): number {
    return VIDEO_DURATION;
  }

  isSeekable(): boolean {
    return false;
  }

  manuallyEndAt(): number | null {
    return this.startTime + this.videoDuration;
  }

  showFuPaTvLogo(): boolean {
    return true;
  }

  getPlayedTime(timeRanges: TimeRanges): number {
    return Math.floor(super.getPlayedTime(timeRanges) / 2);
  }
}
